import { ServerVariableService } from './server-variable.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { ValidationService } from './validation.service';
import { Router } from '@angular/router';
import { ToastrService, ToastrConfig } from 'ngx-toastr';
import { DomSanitizer } from '@angular/platform-browser';
import { ResponseWrapperDTO } from '../../models/response/ResponseWrapperDTO';
import { Deserialize } from 'cerialize';
import { UserMaster } from '../../models/UserMaster';
import { environment } from '../../../environments/environment';
import { PaginationRequest } from '../../models/pagination/PaginationRequest';
import { PaginationResponse } from '../../models/pagination/PaginationResponse';
import { CurrencyPipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { OrderStatusEnum } from '../enums/EnumForSales.enum';
import { saveAs } from 'file-saver';
import printJS from 'print-js';

declare var $: any;
@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  //  For local


  selectedValue: string;
  countOfComplete: number;
  countOfNotification: number = 0;

  DEFAULT_IMAGE_PATH_NEW = 'assets/images/defaultuser.png';

  profilePhotoUrl: string;

  loaderStart = 0;
  msgFromDeleteAPIOnConflicts: string;
  imagePreview: any;
  Pos: number = 0;
  arrayOfapiNameToExcludeToken = [this.serverVariableService.LOGIN_API];
  toastConfig = {
    // disableTimeOut: true,
    // timeOut: 0,
    positionClass: 'toast-top-center',
    closeButton: true,
  };
  screenName: string;
  notificationCounter: number = 0;
  notificationToken: any;

  status: string;
  public arrayOfallUserRights;
  // arrayForMenu: Array<MenuWithUserRightDTO> = new Array<MenuWithUserRightDTO>();
  // arrayForSettingMenu: Array<MenuWithUserRightDTO> = new Array<MenuWithUserRightDTO>();
  flagForViewMaster: boolean;
  public backupOfArrayOfUserRole;
  ServiceList: any[] = [
    { title: 'Open', class: 'icon-eye-outline', id: '1' },
    { title: 'Assign', class: 'icon-user-tick', id: '2' },
    { title: 'In Progress', class: 'icon-refresh', id: '3' },
    { title: 'Completed', class: 'icon-tick-circle', id: '4' },
    { title: 'Closed', class: 'icon-close-circle', id: '5' },
    { title: 'Cancel', class: 'icon-close', id: '6' },
  ]


  eventList = new Array<Event>();
  eventId: string;
  constructor(public http: HttpClient,
    public router: Router,
    public serverVariableService: ServerVariableService,
    public validationService: ValidationService,
    public toasterService: ToastrService,
    public sanitizer: DomSanitizer) {
    this.backupOfArrayOfUserRole = new Object();

  }


  /**
   * @author : Dhrumin-Ranoliya
   * @param isDisplayToast display tost or not , pass true or false
   * @param url API name
   * @param params params
   * @param callback response of server
   */
  postMethodAPI(isDisplayToast: boolean, apiName: any, params: any, callback: (response: any, isRoute: boolean) => void, isCallbackRequired?: boolean, noLoaderRequire?: boolean): Subscription {
    this.loaderStart++;
    if (noLoaderRequire) {
      this.loaderStart--;
    }
    this.customJsonInclude(params);
    let headers = new HttpHeaders();
    if (this.arrayOfapiNameToExcludeToken.indexOf(apiName) < 0) {
      headers = headers.set('App-Token', this.getToken());
    }
    // if (this.ipAddress) {

    //   headers = headers.append('IpAddress', this.ipAddress);

    // }
    apiName = environment.API_URL + apiName;

    return this.http.post(apiName, params, { headers, observe: 'response' }).subscribe((response) => {
      // console.log(response.headers);
      // console.log(response.headers.get('Authorization'));
      // Read the result field from the JSON response.
      if (this.loaderStart > 0) {
        this.loaderStart--;
      }
      const serverResponse = Deserialize(response.body, ResponseWrapperDTO);
      if (!(serverResponse.status < 200 || serverResponse.status >= 300)) {
        if (isDisplayToast) {
          // console.log(serverResponse.message);

          this.toasterService.success(serverResponse.message, '', {
            positionClass: 'toast-top-right',
            closeButton: true
          });
          // if (isToastAndDataBothRequired) {
          //   callback(serverResponse.data, true);
          //   return;
          // }
          // callback(undefined, true);
          // callback(serverResponse.data, true);
          // return;
        }
        if (isCallbackRequired) {
          callback(serverResponse, true);
        } else {

          callback(serverResponse.data, true);
        }
        // callback(serverResponse.data, true);
      }
    },
      (err: HttpErrorResponse) => {
        console.log(`Backend returned code ${err.status}, body was: ${err.message}`);
        if (err.status === 0) {
          // this.goToServerDownPage();
          this.toasterService.error('Unable to Connect with server, Please check your internet connectivity or wait for the network to establish the connection.', '', this.toastConfig);
        } else {
          // console.log('else');

          const errorDTO = Deserialize(err.error, ResponseWrapperDTO);
          //console.log(errorDTO);

          if (errorDTO.status === 401) {
            // this.goToSessionExpired();
            this.toasterService.error(errorDTO.error ? errorDTO.error.message : errorDTO.message, '', this.toastConfig);
            this.logout();
          } else if (errorDTO.status === 403) {
            // this.goToAccessDenied();
            this.toasterService.error(errorDTO.error ? errorDTO.error.message : errorDTO.message, '', this.toastConfig);

          } else {
            this.toasterService.error(errorDTO.error ? errorDTO.error.message : errorDTO.message, '', this.toastConfig);
            if (isCallbackRequired) {
              callback(errorDTO.message, true);
            }
          }

        }
        this.loaderStart--;
      }
    );
  }

  /**
   * @author : Dhrumin-Ranoliya
   * @param API API name
   * @param params params
   * @param callback response of server
   */
  getMethodAPI(apiName: any, params: any, callback: (response: any) => void, noLoaderRequire?: boolean): Subscription {
    this.loaderStart++;
    if (noLoaderRequire) {
      this.loaderStart--;
    }
    let httpParams = new HttpParams();
    if (!this.isNullUndefinedOrBlank(params)) {
      Object.keys(params).forEach(key => {
        if (key && params[key] && params.hasOwnProperty(key) && !this.isEmptyObjectOrNullUndefiend(params[key])) {
          httpParams = httpParams.append(key, params[key]);
        }
      });
    }
    let headers = new HttpHeaders();
    if (this.arrayOfapiNameToExcludeToken.indexOf(apiName) < 0) {
      headers = headers.set('App-Token', this.getToken());
    }
    // if (this.ipAddress) {

    //   headers = headers.append('IpAddress', this.ipAddress);

    // }
    apiName = environment.API_URL + apiName;
    return this.http.get(apiName, { params: httpParams, headers, observe: 'response' }).subscribe(response => {

      // Read the result field from the JSON response.
      if (this.loaderStart > 0) {
        this.loaderStart--;
      }
      const serverResponse = Deserialize(response.body, ResponseWrapperDTO);

      if (serverResponse.status < 200 || serverResponse.status >= 300) {
        // this.setConfigAndDisplayPopUpNotification('error', '', serverResponse.message);
        this.toasterService.error(serverResponse.message, '', this.toastConfig);

      } else {
        callback(serverResponse.data);
      }
    },
      (err: HttpErrorResponse) => {
        console.log(`Backend returned code ${err.status}, body was: ${err.message}`);
        if (err.status === 0) {
          this.toasterService.error('Unable to Connect with server, Please check your internet connectivity or wait for the network to establish the connection.', '', this.toastConfig);
        } else {
          const errorDTO = Deserialize(err.error, ResponseWrapperDTO);
          if (errorDTO.status === 401) {
            // this.goToSessionExpired();
            this.toasterService.error(errorDTO.error ? errorDTO.error.message : errorDTO.message, '', this.toastConfig);
            this.logout();
          } else if (errorDTO.status === 403) {
            // this.goToAccessDenied();
            this.toasterService.error(errorDTO.error ? errorDTO.error.message : errorDTO.message, '', this.toastConfig);


          } else {

            this.toasterService.error(errorDTO.message ? errorDTO.message : errorDTO.error, '', this.toastConfig);
            callback(errorDTO.data);
          }
        }
        this.loaderStart--;
      }
    );
  }
  downloadFileAPI(
    apiName: string,
    params: any,
    callback: (fileData: Blob | ArrayBuffer | null) => void,
    fileType: string = 'application/octet-stream',
    fileName?: string
  ): Subscription {
    this.loaderStart++;

    let httpParams = new HttpParams();
    if (!this.isNullUndefinedOrBlank(params)) {
      Object.keys(params).forEach(key => {
        if (key && params[key] && params.hasOwnProperty(key) && !this.isEmptyObjectOrNullUndefiend(params[key])) {
          httpParams = httpParams.append(key, params[key]);
        }
      });
    }

    let headers = new HttpHeaders();
    if (this.arrayOfapiNameToExcludeToken.indexOf(apiName) < 0) {
      headers = headers.set('App-Token', this.getToken());
    }

    apiName = environment.API_URL + apiName;

    return this.http.get(apiName, {
      params: httpParams,
      headers,
      observe: 'response',
      responseType: 'arraybuffer'  // always binary
    }).subscribe({
      next: (response) => {
        if (this.loaderStart > 0) {
          this.loaderStart--;
        }

        // Convert ArrayBuffer → Blob
        const blob = new Blob([response.body!], { type: fileType });

        // Auto download if fileName is provided
        if (fileName) {
          saveAs(blob, fileName);  // 👈 clean download
        }



        // Send blob back to caller
        callback(blob);
      },
      error: (err: HttpErrorResponse) => {
        console.error(`File download failed. Status: ${err.status}, Message: ${err.message}`);
        this.toasterService.error('File download failed.', '', this.toastConfig);
        this.loaderStart--;
        callback(null);
      }
    });
  }
  printFileAPI(
    apiName: string,
    params: any,
    callback: (fileData: Blob | ArrayBuffer | null) => void,
    fileType: string = 'application/octet-stream',
    fileName?: string
  ): Subscription {
    this.loaderStart++;

    let httpParams = new HttpParams();
    if (!this.isNullUndefinedOrBlank(params)) {
      Object.keys(params).forEach(key => {
        if (key && params[key] && params.hasOwnProperty(key) && !this.isEmptyObjectOrNullUndefiend(params[key])) {
          httpParams = httpParams.append(key, params[key]);
        }
      });
    }

    let headers = new HttpHeaders();
    if (this.arrayOfapiNameToExcludeToken.indexOf(apiName) < 0) {
      headers = headers.set('App-Token', this.getToken());
    }

    apiName = environment.API_URL + apiName;

    return this.http.get(apiName, {
      params: httpParams,
      headers,
      observe: 'response',
      responseType: 'arraybuffer'  // always binary
    }).subscribe({
      next: (response) => {
        if (this.loaderStart > 0) {
          this.loaderStart--;
        }

        // Convert ArrayBuffer → Blob
        const blob = new Blob([response.body!], { type: fileType });

        // Auto download if fileName is provided
        if (fileName) {
          const blobUrl = URL.createObjectURL(blob);
          printJS({
            printable: blobUrl,
            type: 'pdf',
            showModal: false 
          });
        }



        // Send blob back to caller
        callback(blob);
      },
      error: (err: HttpErrorResponse) => {
        console.error(`File download failed. Status: ${err.status}, Message: ${err.message}`);
        this.toasterService.error('File download failed.', '', this.toastConfig);
        this.loaderStart--;
        callback(null);
      }
    });
  }


  /**
   * @author : Dhrumin-Ranoliya
   * @param isDisplayToast
   * @param url
   * @param params
   * @param id
   * @param callback
   */
  putMethodAPI(isDisplayToast: boolean, apiName: any, params: any, id: any, callback: (responseData: any, isRoute: boolean) => void, isCallbackRequired?: boolean): Subscription {

    this.loaderStart++;
    let headers = new HttpHeaders();
    if (this.arrayOfapiNameToExcludeToken.indexOf(apiName) < 0) {
      headers = headers.set('App-Token', this.getToken());
    }
    apiName = id ? (environment.API_URL + apiName + '/' + id) : environment.API_URL + apiName;
    return this.http.put(apiName, params, { headers, observe: 'response' }).subscribe(
      response => {
        console.error(response);
        // Read the result field from the JSON response.
        if (this.loaderStart > 0) {
          this.loaderStart--;
        }
        const serverResponse = Deserialize(response.body, ResponseWrapperDTO);
        if (!(serverResponse.status < 200 || serverResponse.status >= 300)) {
          if (isDisplayToast) {
            this.toasterService.success(serverResponse.message, '', {
              positionClass: 'toast-top-right',
              closeButton: true
            });
          }
          callback(serverResponse.data, true);
          // if (serverResponse.data && typeof serverResponse.data !== 'string') {
          //   console.log(serverResponse.data);
          //   callback(serverResponse.data, true);
          // }
        }
      },
      (err: HttpErrorResponse) => {
        console.log(`Backend returned code ${err.status}, body was: ${err.message}`);
        if (err.status === 0) {
          this.toasterService.error('Unable to Connect with server, Please check your internet connectivity or wait for the network to establish the connection.', '', this.toastConfig);

        } else {
          const errorDTO = Deserialize(err.error, ResponseWrapperDTO);
          console.log('isResponsePage', errorDTO);
          console.log(errorDTO.status);

          if (errorDTO.status === 401) {
            // this.goToSessionExpired();
            this.toasterService.error(errorDTO.error ? errorDTO.error.message : errorDTO.message, '', this.toastConfig);
            this.logout();
          } else if (errorDTO.status === 403) {
            // this.goToAccessDenied();
            this.toasterService.error(errorDTO.error ? errorDTO.error.message : errorDTO.message, '', this.toastConfig);


          } else {
            this.toasterService.error(errorDTO.message ? errorDTO.message : errorDTO.error, '', this.toastConfig);

            // if (isCallbackRequired) {
            //   callback(errorDTO.message, true);
            // } else {
            //   callback(errorDTO.message, false);
            // }

          }
        }
        this.loaderStart--;
      });
  }

  /**
   * @author : Dhrumin-Ranoliya
   * @param isDisplayToast
   * @param url
   * @param params
   * @param id
   * @param callback
   */
  deleteMethodAPI(isDisplayToast: boolean, apiName: any, ob: any, callback: (response: any) => void): Subscription {
    this.loaderStart++;
    let headers = new HttpHeaders();
    if (this.arrayOfapiNameToExcludeToken.indexOf(apiName) < 0) {
      headers = headers.set('App-Token', this.getToken());
    }

    apiName = environment.API_URL + apiName;
    // console.log(JSON.stringify(ob));
    Object.keys(ob).forEach(key => {
      if (key && ob[key] && ob.hasOwnProperty(key) && !this.isEmptyObject(ob[key])) {
        // console.log('value ::' + ob[key]);
        apiName += '/' + ob[key];
        // console.log('API  ::' + apiName);
      }
    });
    return this.http.delete(apiName, { headers, observe: 'response' }).subscribe(
      response => {

        // Read the result field from the JSON response.
        if (this.loaderStart > 0) {
          this.loaderStart--;
        }

        const serverResponse = Deserialize(response.body, ResponseWrapperDTO);
        if (!(serverResponse.status < 200 || serverResponse.status >= 300)) {
          if (isDisplayToast) {
            this.toasterService.success(serverResponse.message, '', {
              positionClass: 'toast-top-right',
              closeButton: true
            });
          }
          callback(serverResponse.data);
        }
      },
      (err: HttpErrorResponse) => {
        console.log(`Backend returned code ${err.status}, body was: ${err.message}`);
        if (err.status === 0) {
          this.toasterService.error('Unable to Connect with server, Please check your internet connectivity or wait for the network to establish the connection.', '', this.toastConfig);

        } else {
          // console.log(err.error);
          const errorDTO = Deserialize(err.error, ResponseWrapperDTO);
          // console.log(errorDTO.message);

          if (errorDTO.status === 401) {
            // this.goToSessionExpired();
            this.toasterService.error(errorDTO.error ? errorDTO.error.message : errorDTO.message, '', this.toastConfig);
            this.logout();

          } else if (errorDTO.status === 403) {
            // this.goToAccessDenied();
            this.toasterService.error(errorDTO.error ? errorDTO.error.message : errorDTO.message, '', this.toastConfig);


          } else {
            console.log(errorDTO.message);

            this.toasterService.error(errorDTO.message ? errorDTO.message : errorDTO.error, '', this.toastConfig);
          }
        }
        this.loaderStart--;
      });
  }

  getToken(): any {
    return sessionStorage.getItem('token') ? sessionStorage.getItem('token') : null;
  }


  getTextboxValue(getText, event1, eventKeyCode, maximum, decimalPoint) {
    let pattern;
    const name = getText.value;
    if (decimalPoint === 0) {
      pattern = /[0-9]/;
    } else {
      pattern = /[0-9\.\ ]/;
    }

    let setLength;
    if (name.indexOf('-') !== -1) {
      setLength = maximum + 1;
    } else {
      if (getText.selectionStart || getText.selectionStart == '0') {
        this.Pos = getText.selectionStart;
        if (this.Pos === 0 && name.indexOf('-') === -1 && eventKeyCode === 45) {
          setLength = maximum + 1;
        } else {
          setLength = maximum;
        }
      }
    }
    const decimal = decimalPoint + 1;
    const inputChar = String.fromCharCode(eventKeyCode);

    if (eventKeyCode !== 8 && !pattern.test(inputChar)) {

      event1.preventDefault();
    }
    if (eventKeyCode === 46) {
      if (name.indexOf('.') === -1) {
        getText.maxLength = name.length + decimal;
      } else {
        getText.maxLength = setLength;
        if (setLength !== name.length) {
          getText.maxLength = name.length;
        }
      }
    } else {
      if (name.indexOf('.') === -1) {
        getText.maxLength = setLength;
      } else {
        const lengthOfFristIndex = name.split('.')[0].length;
        const lengthOfLatsIndex = name.split('.')[1].length;
        getText.maxLength = setLength;
        getText.maxLength = lengthOfFristIndex + decimal;
        if (getText.selectionStart || getText.selectionStart === '0') {
          this.Pos = getText.selectionStart;
          if (this.Pos <= lengthOfFristIndex && lengthOfFristIndex <= setLength) {
            if (lengthOfFristIndex === setLength) {
              var setLen = lengthOfFristIndex + lengthOfLatsIndex + 1;
              getText.maxLength = setLen;
            } else {
              setLen = (name.length - 1) + (setLength - lengthOfFristIndex) + (decimal - lengthOfLatsIndex);
              getText.maxLength = setLen;
            }
          }
        }
      }
    }
  }
  checkgetText(textValue, maxLength, decimalPoint) {
    console.log(textValue);
    const getText = textValue.value;
    const pattern = /[0-9\+\-\ ]/;
    // if (getText != 'MAX' && getText != 0 && !pattern.test(getText)) {
    //   textValue.value = 0;
    // }
    console.log(getText.indexOf('.'));

    getText && getText.indexOf('.') === 0 ? textValue.value = 0 : '';

    getText && getText.indexOf('-') !== -1 ? maxLength = maxLength + 1 : '';
    getText && getText.indexOf('.') !== -1 && getText.split('.')[1].length > decimalPoint ? textValue.value = getText.slice(0, getText.indexOf('.') + 1 + decimalPoint) : '';
    getText && getText.indexOf('.') === -1 && getText.length > maxLength ? textValue.value = getText.slice(0, maxLength) : '';
    if (getText && getText.split('.')[0].length === 0 && getText.split('.')[1].length !== 0) {
      textValue.value = (0 + getText);
    }
    console.log(parseInt(textValue.value));
  }

  /**
   * This Method Is Use For Remove Blank And Null Key From Object.
   */
  customJsonInclude(obj): void {
    for (const key in obj) {
      if (typeof obj[key] === 'object') {
        if (obj[key] && obj[key].length > 0) {
          obj[key] = this.removeEmptyElementsFromArray(obj[key]);
        }
        if (this.isEmptyObject(obj[key])) {
          delete obj[key];
        } else {
          this.customJsonInclude(obj[key]);
        }
      } else {
        if (obj[key] === undefined || obj[key] === null) {
          delete obj[key];
        }
      }
    }
  }

  /**
   * This Method Is Use From Remove Empty Element From Array
   * @param test_array  your selected array pass as args.
   */
  removeEmptyElementsFromArray(test_array): Array<any> {
    let index = -1;
    const arr_length = test_array ? test_array.length : 0;
    let resIndex = -1;
    const result = [];

    while (++index < arr_length) {
      const id = test_array[index];
      if (id) {
        result[++resIndex] = id;
      }
    }
    return result;
  }

  setDecimalPointValue(number: number): number {
    if (Number.isNaN(number)) {
      return 0;
    } else {
      return +number.toFixed(2);
    }
  }

  isAuthenticated(): string {
    return localStorage.getItem('isAuthenticate') ? localStorage.getItem('isAuthenticate') : null;
  }

  isNullUndefinedOrBlank(obj): boolean {
    if (obj == null || obj === undefined || (obj === '' && obj !== 0)) {
      return true;
    }
    return false;
  }
  isEmptyObjectOrNullUndefiend(...value): boolean {
    if (value && value.length > 0) {
      for (let i = 0; i < value.length; i++) {
        if (this.isNullUndefinedOrBlank(value[i]) || this.isEmptyObject(value[i])) {
          return true;
        }
      }
    }
    return false;
  }



  getUserId(): string {
    if (this.isEmptyObject(JSON.parse(localStorage.getItem(this.serverVariableService.USER_OF_LOCAL_STORAGE)))) {
      return null;
    }
    let user = new UserMaster();
    user = Deserialize(JSON.parse(localStorage.getItem(this.serverVariableService.USER_OF_LOCAL_STORAGE)), UserMaster);
    return user ? user.id : null;
  }

  redirectTo(...route): void {
    this.router.navigate(route);
  }

  redirectToWithQueryParam(param, route: Array<string>): void {
    // console.warn(param);
    // console.warn(route);
    this.router.navigate(route, { queryParams: param });
  }

  getUserRoleByRoleName(role): boolean {
    return this.getLoginUsers().role.name === role ? true : false;
  }

  /*
  *
  * Used to check if object ios empaty or not..!
  * @param obj = 'indecated object which you want to check'
  * return true if empty..!
  */
  isEmptyObject(obj): boolean {
    return (obj && (Object.keys(obj).length === 0));
  }


  removeDublicateSpaceFromString(str?: string): string {
    return str.replace(/\s+/g, ' ');
  }

  setZeroBeforeNumericValue(num: string, size?: number): string {
    if (!size) {
      size = 4;
    }
    let s = num + '';
    while (s.length < size) {
      s = '0' + s;
    }
    return s;
  }
  decodeToken(token): string | any {
    if (!this.isNullUndefinedOrBlank(token)) {
      const jwt = token.split('.')[1];
      const decodedJwtJsonData = JSON.parse(window.atob(jwt));
      return decodedJwtJsonData;
    }
  }

  isNumeric(value): boolean {
    return /^\d+$/.test(value);
  }
  public getQueryString(ob) {
    let i = 0;
    let param: string;
    param = '';
    for (const key in ob) {
      if (ob[key]) {
        param += ((i === 0) ? '?' : '&') + key + '=' + ob[key];
        i++;
      }
    }
    return (param) ? param : undefined;
  }

  /**
   * @author Dhrumin Ranoliya
   * @param modalId : id for hideModal
   * @function hideModal used for hide opened modal using modalId
   */
  hideModal(modalId: string): void {
    $('' + '#' + modalId + '').modal('hide');
  }

  // to get Login Users from local storage
  getLoginUsers(): UserMaster | any {
    const user = JSON.parse(sessionStorage.getItem('user'));
    if (user != null) {
      return user;
    }
  }

  /**
   * @author Dhrumin Ranoliya
   * @param modalId : id for openModal
   * @function openModal used for open modal using modalId
   */
  openModal(modalId: string): void {
    $('' + '#' + modalId + '').modal({ backdrop: 'static', keyboard: false });
  }

  getAccessToken(): string {
    const user = JSON.parse(localStorage.getItem('employee'));
    return user.token;
  }
  convertDateFormat(dateObj): Date | any {
    const date = new Date();
    if (dateObj) {
      dateObj.setHours(date.getHours());
      dateObj.setMinutes(date.getMinutes());
      dateObj.setSeconds(date.getSeconds());
      return dateObj;
    }
  }
  /* If search text is valid then call api. */
  isCallSearchAPI(value): boolean {
    console.log(value);

    if (value.length === 0 && value.trim().length === 0) {
      return true;
    }
    if (value.trim().length) {
      return true;
    } else {
      return false;
    }
  }
  preventSpace(event): void {
    event.target.value = event.target.value.replace(/^\s+/g, '');
  }
  /* Image Preview*/
  readUrl(event, callback: (response) => void) {
    if (event.target.files && event.target.files[0]) {
      let reader: any;
      reader = new FileReader();
      reader.onload = (e) => {
        this.imagePreview = e.target.result;
        return callback(this.imagePreview);
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }
  /* End Image Preview*/


  setSettingForLocalStorage(params) {
    localStorage.setItem('flagForMenu', JSON.stringify(params));
  }
  getSettingForLocalStorage() {
    return localStorage.getItem('flagForMenu');
  }

  // downloadFileAPI(docId: string) {
  //   const param = {
  //     id: docId
  //   };
  //   this.getMethodAPI(this.serverVariableService.downloadFileAPI, param, (response) => {

  //   });
  // }

  // download(docId) {
  //   const url = environment.API_URL + this.serverVariableService.downloadFileAPI + '?id=' + docId;
  //   const dlLink = document.createElement('a');
  //   dlLink.setAttribute('crossOrigin', 'anonymous');
  //   dlLink.setAttribute('data-downloadurl', url);
  //   dlLink.href = url;
  //   dlLink.download = 'downloadfile.png';
  //   dlLink.dataset.downloadurl = [dlLink.download, url['href']].join(':');
  //   document.body.appendChild(dlLink);
  //   dlLink.click();
  //   document.body.removeChild(dlLink);
  // }




  iframeURL(url) {
    // const urls: any = this.sanitizer.bypassSecurityTrustUrl(url);
    // return urls.changingThisBreaksApplicationSecurity;
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }


  setDateWithTimeZero(dateObj) {
    if (dateObj) {
      dateObj.setHours(0);
      dateObj.setMinutes(0);
      dateObj.setSeconds(0);
      dateObj.setMilliseconds(0);
      // dateObj.setTime(0);
      return dateObj;
    }
    return dateObj;
  }

  convertBase64ToBlob(imageBase64: string) {
    const ImageURL = imageBase64;
    // Split the base64 string in data and contentType
    const block = ImageURL.split(';');
    // Get the content type of the image
    const contentType = block[0].split(':')[1];// In this case 'image/gif'
    // get the real base64 content of the file
    const realData = block[1].split(',')[1];// In this case 'R0lGODlhPQBEAPeoAJosM....'

    // Convert it to a blob to upload
    const blob = this.b64toBlob(realData, contentType);
    return blob;
  }


  /**
  * Convert a base64 string in a Blob according to the data and contentType.
  *
  * @param b64Data {String} Pure base64 string without contentType
  * @param contentType {String} the content type of the file i.e (image/jpeg - image/png - text/plain)
  * @param sliceSize {Int} SliceSize to process the byteCharacters
  * @return Blob
  */
  b64toBlob(b64Data, contentType, sliceSize?) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }


  // .......... Start Pagination Related Methods ...............

  public getPreviousData(pagination: PaginationRequest) {
    pagination.pageNumber = (+pagination.pageNumber - 1).toString();
  }
  public getNextData(pagination: PaginationRequest) {
    pagination.pageNumber = (+pagination.pageNumber + 1).toString();
  }

  public changeNoOfRecord(pagination: PaginationRequest) {
    pagination.pageNumber = String(1);
  }

  public setSortByKeyAndOrder(pagination: PaginationRequest, key: string) {
    let className = '';
    if (pagination.sortColumn && pagination.sortColumn === key) {
      if (pagination.sortOrder === 'a') {
        pagination.sortOrder = 'd';
        className = 'shorting mdi mdi-arrow-up';
      } else {
        pagination.sortOrder = 'a';
        className = 'shorting mdi mdi-arrow-down';
      }
    } else {
      pagination.sortColumn = key;
      pagination.sortOrder = 'd';
      className = 'shorting mdi mdi-arrow-up';
    }
    pagination.classForUpDown = className;
  }

  setPaginationSetting(pagination: PaginationResponse) {
    if (pagination) {
      pagination.startPos = +pagination.pageable['offset'] + 1;
      pagination.endPos = +pagination.pageable['offset'] + +pagination.size;
      if (pagination.totalPages) {
        for (let i = 0; i < pagination.totalPages; i++) {
          pagination.pageArray.push({
            id: (i + 1).toString(),
            name: 'Page ' + (i + 1)
          });
        }
      }
    }
    return pagination;
  }

  setPaginationOnDeleteAndUpdateRecords(
    last: boolean,
    numberOfElements: number,
    paginationRequest: PaginationRequest
  ) {
    console.log(last + '' + numberOfElements + '' + paginationRequest);

    if (last && numberOfElements === 1 && paginationRequest.pageNumber !== '1') {

      paginationRequest.pageNumber = (+paginationRequest.pageNumber - 1).toString();
    }
    return paginationRequest;
  }
  // .......... End Pagination Related Methods ...............


  // download(docId) {
  //   const url = environment.API_URL + this.serverVariableService.downloadFileAPI + '?id=' + docId;
  //   const dlLink = document.createElement('a');
  //   dlLink.setAttribute('crossOrigin', 'anonymous');
  //   dlLink.setAttribute('data-downloadurl', url);
  //   dlLink.href = url;
  //   dlLink.download = 'downloadfile.png';
  //   dlLink.dataset.downloadurl = [dlLink.download, url['href']].join(':');
  //   document.body.appendChild(dlLink);
  //   dlLink.click();
  //   document.body.removeChild(dlLink);
  // }
  // downloadBackupDB() {
  //   const url = environment.API_URL + this.serverVariableService.getDBBackupAPI;
  //   const dlLink = document.createElement('a');
  //   dlLink.setAttribute('crossOrigin', 'anonymous');
  //   dlLink.setAttribute('data-downloadurl', url);
  //   dlLink.href = url;
  //   dlLink.download = 'downloadfile.png';
  //   dlLink.dataset.downloadurl = [dlLink.download, url['href']].join(':');
  //   document.body.appendChild(dlLink);
  //   dlLink.click();
  //   document.body.removeChild(dlLink);
  // }

  convertoToINRFormat(val: number) {
    return val.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  convertPriceByCurrencyCode(val: number, currencyCode: string) {
    const loacalId = currencyCode === 'INR' ? 'en-IN' : 'en-US';
    const symbol = currencyCode === 'INR' ? '₹' : '$';

    return (symbol + val.toLocaleString(loacalId, { minimumFractionDigits: 2, maximumFractionDigits: 2 }));

  }

  goToSessionExpired() {
    localStorage.clear();
    sessionStorage.clear();
    this.redirectTo('/session-expired');
  }
  goToAccessDenied() {
    this.redirectTo('/access-denied');
  }

  getAddressDiffMessage(): string {
    return 'If addresses differs please uncheck below boxes';
  }

  openDocumentUrlNewTab(URL) {
    window.open(URL, '_blank');
  }


  /**
   * Decimal adjustment of a number.
   *
   * @param {String}  type  The type of adjustment.
   * @param {Number}  value The number.
   * @param {Integer} exp   The exponent (the 10 logarithm of the adjustment base).
   * @returns {Number} The adjusted value.
   */
  decimalAdjust(type, value, exp) {
    // If the exp is undefined or zero...
    if (typeof exp === 'undefined' || +exp === 0) {
      return Math[type](value);
    }
    value = +value;
    exp = +exp;
    // If the value is not a number or the exp is not an integer...
    if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
      return NaN;
    }
    // Shift
    value = value.toString().split('e');
    value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
    // Shift back
    value = value.toString().split('e');
    return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
  }

  logout(): void {

    const param = {};
    let userDetail = JSON.parse(sessionStorage.getItem('user'));

    const Id = userDetail.id;

    this.postMethodAPI(true, this.serverVariableService.LOGOUT_API + `/${Id}`, param, (response) => {
      sessionStorage.clear();
      localStorage.clear();
      this.redirectTo('/auth/login');
    });

  }

  cloneObject(obj) {
    return JSON.parse(JSON.stringify(obj))
  }

  sortArrayOfObject(array, key) {
    array.sort((a: any, b: any) => {
      const val1 = a[key];
      const val2 = b[key];
      if (val1 > val2) {
        return -1;
      } else if (val1 < val2) {
        return 1;
      } else {
        return 0;
      }
    });
    return array;
  }

  handleGetStatusName = (statusId) => {
    let statusName = '';
    let statusClassName = '';
    switch (statusId) {
      case OrderStatusEnum.ChinaOrderPlaced:
        statusName = 'China Order Placed';
        statusClassName = 'sales-order-china-orders';
        break;
      case OrderStatusEnum.BodyPlan:
        statusName = 'Body Plan';
        statusClassName = 'sales-order-body-plan';
        break;
      case OrderStatusEnum.ShipmentDetails:
        statusName = 'Shipment Details';
        statusClassName = 'sales-order-shipment';
        break;
      case OrderStatusEnum.Delivered:
        statusName = 'Delivered';
        statusClassName = 'sales-order-delivered';
        break;
      case OrderStatusEnum.Orders:
        statusName = 'Orders';
        statusClassName = 'sales-order-accept';
        break;
      // case OrderStatusEnum.Accept:
      //   statusName = 'Approved';
      //   statusClassName = 'sales-order-accept';
      //   break;
      case OrderStatusEnum.Decline:
        statusName = 'Declined';
        statusClassName = 'sales-order-decline';
        break;
      default:
        statusName = 'In Order';
        statusClassName = 'sales-order-orders';
        break;
    }
    return { statusName, statusClassName };
  }
  handleGetUserId = () => {
    let userDetail = JSON.parse(sessionStorage.getItem('user'));

    const Id = userDetail.id;
    return Id || "";
  }

}


